import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "vueMain" }
const _hoisted_2 = { class: "ng-extend" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "neuroglancer-container" })
], -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["ExtensionBar"])
    ]),
    _createVNode($setup["SplitMergeOverlay"]),
    _hoisted_3
  ]))
}